import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { WhatsappCampaignContent } from './WhatsappCampaignContent';
import { WHATSAPP_CAMPAIGN_FORM_SCHEMA, WhatsappCampaignFormInput, WhatsappCampaignFormOutput } from './WhatsappCampaignValidation';
import { WhatsappCampaignMode } from './WhatsappCampaignSteps';

type WhatsappCampaignProps = {
  mode?: WhatsappCampaignMode;
  campaignId?: string;
  onExitToList?: () => void;
};

export const WhatsappCampaign: FC<WhatsappCampaignProps> = ({ mode = 'create', campaignId, onExitToList }) => {
  const methods = useForm<WhatsappCampaignFormInput, unknown, WhatsappCampaignFormOutput>({
    resolver: zodResolver(WHATSAPP_CAMPAIGN_FORM_SCHEMA),
    defaultValues: {
      name: '',
      description: '',
      templateId: '',
      templateName: undefined,
      audienceId: '',
      connectorFlowId: '',
      connectorId: '',
      scheduleType: 'sendNow',
      scheduleStart: undefined,
      scheduleEnd: undefined,
    },
    mode: 'onTouched',
  });

  const onSubmit = (_data: WhatsappCampaignFormOutput) => {
    // Submit is intentionally controlled by step actions.
  };

  return (
    <FormProvider {...methods}>
      <form className='flex min-h-full flex-col gap-6 p-8' onSubmit={methods.handleSubmit(onSubmit)}>
        <WhatsappCampaignContent mode={mode} campaignId={campaignId} onExitToList={onExitToList} />
      </form>
    </FormProvider>
  );
};
